'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:train:gotoOrderDetail');
}

var _invoke = require('../invoke');

/**
 * 进入火车票订单详情页面
 *
 * 点击后退时会返回订单列表页面，再后退会返回我的页面
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof train
 * @static
 * @name gotoOrderDetail
 * @param {String} url 订单页面地址
 * @param {String} orderListUrl 订单列表页面地址
 * @return {Undefined}
 * @example
 *  hbnb.train.gotoOrderDetail(
 *      'url'
 *      'orderListUrl'
 *  );
 */
module.exports = function(url, orderListUrl) {
    if (process.env.NODE_ENV !== 'production') {
        debug('url is %s', url);
        debug('orderListUrl is %s', orderListUrl);
    }

    _invoke('train', 'goto_order_detail', {
        url: url,
        orderListUrl: orderListUrl
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/train/goto-order-detail.js
// module id = 628
// module chunks = 0